import { FC } from 'react'

import { Stack, Typography } from '@mui/material'

import Title from './Title'

const PasswordResetResult: FC = () => {
  const isSuccess = document.querySelector('#password-reset-success')

  return (
    <Stack spacing={6}>
      <Title>{isSuccess ? 'Password reset successfully' : 'An error occurred'}</Title>
      <Typography>
        {isSuccess
          ? 'Your password has been successfully reset. You can now log into the Phillips app with your new password.'
          : 'Oops! There was a problem resetting your password. We are currently working on resolving it. Please try again later.'}
      </Typography>
    </Stack>
  )
}

export default PasswordResetResult
